export default "__VITE_ASSET__Chg$5D1___"